<template>
  <v-menu
    ref="dateMenu"
    v-model="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="currentValue"
        v-bind="attrs"
        v-on="on"
        required
        :rules="rules"
        :clearable="!readonly && !rules"
        @input="_fnClearInput"
        readonly
      >
        <template #label>
          {{ label || $t(`table.dateRange`) }}
          <span v-if="rules" class="red--text">
            <strong>*</strong>
          </span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      color="primary"
      v-if="!readonly"
      v-model="date"
      no-title
      @input="_fnDateInput"
      range
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    value: Array,
    rules: Array,
    readonly: Boolean,
  },
  data() {
    return {
      dateMenu: false,
      date: [],
      currentValue: "",
    };
  },
  created() {
    if (this.value && this.value.length === 2) {
      const s = this.$moment.unix(this.value[0]);
      const e = this.$moment.unix(this.value[1]);
      this.date = [s.format("YYYY-MM-DD"), e.format("YYYY-MM-DD")];
      this.currentValue = `${this._fnFormatDate(
        this.date[0]
      )} ~ ${this._fnFormatDate(this.date[1])}`;
      this.$emit("change", [s.utc().unix(), e.utc().unix()]);
    }
  },
  methods: {
    _fnFormatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    _fnDateInput(date) {
      if (date.length && date.length == 2) {
        this.currentValue = `${this._fnFormatDate(
          date[0]
        )} ~ ${this._fnFormatDate(date[1])}`;
        const start = this.$moment(date[0], "YYYY-MM-DD").startOf("day").unix();
        const end = this.$moment(date[1], "YYYY-MM-DD").endOf("day").unix();
        if (start > end) {
          this.currentValue = `${this._fnFormatDate(
            date[1]
          )} ~ ${this._fnFormatDate(date[0])}`;
          this.$emit("change", [end, start]);
        } else {
          this.$emit("change", [start, end]);
        }
      }
    },
    _fnClearInput() {
      this.date = [];
      this.currentValue = "";
      this.$emit("change", []);
    },
  },
};
</script>
